var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "scrollbar",
      rawName: "v-scrollbar",
      value: {
        id: 'list-layout-scroll',
        onScrollEnd: function onScrollEnd() {
          return _vm.$emit('scroll-end');
        }
      },
      expression: "{ id: 'list-layout-scroll', onScrollEnd: () => $emit('scroll-end') }"
    }],
    ref: "mainContainer",
    staticClass: "list-layout-container",
    class: {
      stretch: _vm.isStretchContent
    }
  }, [_c('cs-scrollbar-vertical', {
    staticClass: "list-layout-scroll",
    attrs: {
      "id": "scroll-content"
    }
  }), _c('div', {
    staticClass: "layout-content"
  }, [_c('substrate-mount', {
    ref: "list",
    attrs: {
      "flat": ""
    }
  }, [_vm._t("default")], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }